function place2string(place) {
  //let str = `${place.street_number} ${place.route}, ${place.locality} ${place.administrative_area_level_1}, ${place.country}`;
  let str = place.autocompleteText;
  return str;
}

export default place2string;
